import { gql } from '@apollo/client';

export default gql`
    subscription entityAboutChange($type: String!, $id: ID!) {
        onEntityChange(type: $type, id: $id) {
            id
            name
            description
            image
            active
            iconName
            iconColor
            iconType
            primary
            modifiedDate
            modifiedBy {
                id
                name
                image
            }
        }
    }
`;
